import { Component, OnInit } from '@angular/core';
import { SessionStorageService } from 'ngx-webstorage';
import { Router, ActivatedRoute } from '@angular/router';


//import { NavMenuService } from '../nav-menu/nav-menu.service';
import { AuthenticationService } from '../core';


@Component({
  selector: 'app-top-header',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.css'],
  standalone: false
})
export class TopHeaderComponent implements OnInit {

  constructor(
    //public navMenuService: NavMenuService,
    private auth: AuthenticationService,
    private session: SessionStorageService,
    private router: Router
  ) { }

  showNav: boolean = false;
  ngOnInit() {
  }

  logout() {
    if (this.auth.isLoggedIn) {
      this.clearSession();
    }
  }

  clearSession() {
    this.auth.accessToken = '';
    this.auth.userRoles = [];
    this.session.clear;
    this.auth.logout;
    this.router.navigate(['/login']);
  }

  //toggleNav() {
  //  this.showNav = !this.showNav;
  //  if (this.showNav) {
  //    this.navMenuService.openNav();
  //  } else {
  //    this.navMenuService.closeNav();
  //  }
  //}

}
